interface OptionItem {
  id: string;
  label: string;
}

interface CheckboxListProps {
  options: OptionItem[];
  values: string[];
  onChange: (next: string[]) => void;
}

export function CheckboxList({ options, values, onChange }: CheckboxListProps) {
  const toggle = (id: string) => {
    if (values.includes(id)) onChange(values.filter((v) => v !== id));
    else onChange([...values, id]);
  };

  return (
    <ul className="space-y-2.5">
      {options.map((opt) => {
        const checked = values.includes(opt.id);
        return (
          <li key={opt.id}>
            <button
              type="button"
              role="checkbox"
              aria-checked={checked}
              onClick={() => toggle(opt.id)}
              className="checkbox-row"
            >
              <span
                className={`flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition ${
                  checked ? 'bg-brand border-brand' : 'border-ink-light bg-white'
                }`}
              >
                {checked && (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </span>
              <span className="flex-1">{opt.label}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
